import { getRoot } from "mobx-state-tree"

export const productsFactoryViews = self => ({
  get categoriesFactory() {
    return getRoot(self).categoriesFactory
  },
  get effectsFactory() {
    return getRoot(self).effectsFactory
  }
})